





















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import api from '../store/api';
import { SaveMatchPayload, Match, MatchDay, ScheduleState, ScoreType, MatchDayType, MatchType, EditMode } from '../store/models';
import Notify from '@/shared/services/Notify/Notify';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { ScoreTypeOptions } from '@/shared/consts/ScoreTypeOptions';

import { teamsModuleName } from '@/modules/teams/store/index';
import { Getters as TeamsGetters } from '@/modules/teams/store/getters';
const teamsModule = namespace(teamsModuleName);

import { playersModuleName } from '@/modules/players/store/index';
import { Getters as PlayersGetters } from '@/modules/players/store/getters';
import { Actions as PlayersActions } from '@/modules/players/store/actions';
const playersModule = namespace(playersModuleName);

import { leagueModuleName } from '@/modules/league/store/index';
import { Getters as LeagueGetters } from '@/modules/league/store/getters';
import { Actions as LeagueActions } from '@/modules/league/store/actions';
const leagueModule = namespace(leagueModuleName);

import { scheduleModuleName } from '@/modules/schedule/store/index';
import { Getters as ScheduleGetters } from '@/modules/schedule/store/getters';
import { Team } from '@/modules/teams/store/models';
import { PlayerListItem } from '@/modules/players/store/models';
const scheduleModule = namespace(scheduleModuleName);

@Component({
  components: {
  },
})
export default class EditMatch extends Vue {
  @Prop() private matchId: number | undefined;
  @Prop() private matchDayId: number | undefined;

  private match!: Match;
  private matchDay!: MatchDay;

  private isBusy: boolean = false;
  private editMode: EditMode = EditMode.General;

  private homeTeam: Team | undefined;
  private awayTeam: Team | undefined;
  private homeTeamName: string = '';
  private awayTeamName: string = '';
  private matchDate: string = '';
  private matchTime: string = '';
  private scoreTypeOptions = ScoreTypeOptions;
  private scoreType: ScoreType = ScoreType.NoScore;
  private homeTeamScore: number = 0;
  private awayTeamScore: number = 0;
  private matchReport: string = '';

  private startingPlayersNames: string[] = new Array<string>(11);
  private startingPlayersNumbers: number[] = new Array<number>(11);
  private substitutionPlayersNames: string[] = new Array<string>(7);
  private substitutionPlayersNumbers: number[] = new Array<number>(7);

  private editor: any = ClassicEditor;
  private editorConfig: any = {};

  @teamsModule.Getter(TeamsGetters.TEAMS) private teams!: Team[];
  @teamsModule.Getter(TeamsGetters.ID) private getId!: (name: string) => number;
  @playersModule.Getter(PlayersGetters.PLAYERS) private players!: PlayerListItem[];
  @playersModule.Getter(PlayersGetters.LOADED) private playersLoaded!: boolean;
  @playersModule.Action(PlayersActions.FETCH_PLAYERS) private fetchPlayers!: (seasonId: number) => void;
  @leagueModule.Action(LeagueActions.FETCH_LEAGUE_SETTINGS) private fetchLeagueSettings!: () => void;
  @leagueModule.Getter(LeagueGetters.LOADED) private leagueSettingsLoaded!: number;
  @leagueModule.Getter(LeagueGetters.ACTIVE_SEASON_ID) private activeSeasonId!: number;
  @scheduleModule.Getter(ScheduleGetters.MATCH_DAY) private getMatchDay!: (matchDayId: number) => MatchDay;
  @scheduleModule.Getter(ScheduleGetters.MATCH) private getMatch!: (matchId: number, matchDayId: number) => Match | undefined;

  private async setMode(editMode: EditMode) {
    this.editMode = editMode;
    if (this.editMode === EditMode.Players && !this.playersLoaded) {
      this.isBusy = true;
      if (!this.leagueSettingsLoaded) {
        await this.fetchLeagueSettings();
      }
      await this.fetchPlayers(this.activeSeasonId);
      this.isBusy = false;
    }
  }

  private getAppropriateVariant(editMode: EditMode): string {
    return this.isMode(editMode) ? 'primary' : 'outline-primary';
  }

  private isMode(editMode: EditMode): boolean {
   return this.editMode === editMode;
  }

  private isEditMode(): boolean {
    return this.matchId !== undefined && this.matchId !== 0;
  }

  private formIsValid() {
    return this.teamsInRange() && this.matchDate && this.matchTime;
  }
  get getTitle(): string {
    return this.isEditMode() ? 'Edycja meczu'  : 'Nowe spotkanie meczowe';
  }

  private setIsBusyFalseAndHideModal() {
    this.isBusy = false;
    (this as any).$bvModal.hide('editMatchModal');
  }

  public handleSave(event: any) {
    event.preventDefault();
    if (!this.formIsValid()) {
      return;
    }

    this.isBusy = true;
    const saveMatchPayload: SaveMatchPayload = {
        id: this.isEditMode() ? this.matchId : undefined,
        matchDayId: this.matchDayId,
        matchType: this.matchDay.matchDayType as number as  MatchType,
        matchDateTime: this.$moment.utc(this.matchDate + 'T' + this.matchTime).toDate(),
        teamHomeId: this.getId(this.homeTeamName),
        teamAwayId: this.getId(this.awayTeamName),
        scoreType: this.scoreType as number,
        homeTeamScore: this.scoreType !== ScoreType.NoScore ? this.homeTeamScore : undefined,
        awayTeamScore: this.scoreType !== ScoreType.NoScore ? this.awayTeamScore : undefined,
        report: this.matchReport ? undefined : this.matchReport,
    };

    api.saveMatch(saveMatchPayload)
    .then(() => {
      this.$emit('saveMatchSucceeded', this.matchDayId);
      Notify.success('Match have been saved.');
    })
    .catch(() => {
      Notify.error('Saving match failed');
    })
    .finally(() => setTimeout(this.setIsBusyFalseAndHideModal.bind(this), 500));
  }

  private handleShow() {
    this.isBusy = true;

    this.determineVariantMode();
    this.clearForm();

    this.matchDay = this.getMatchDay(this.matchDayId as number);

    if (this.matchId === undefined || this.matchId === 0) {
      this.matchDate = this.$moment(this.matchDay.defaultDateTime).format('YYYY-MM-DD');
      this.matchTime = this.$moment(this.matchDay.defaultDateTime).format('HH:mm:ss');
    } else {
      this.match = this.getMatch(this.matchId, this.matchDayId as number) as Match;
      this.homeTeamName = this.match.teamHomeName;
      this.awayTeamName = this.match.teamAwayName;
      this.matchDate = this.$moment(this.match.matchDateTime).format('YYYY-MM-DD');
      this.matchTime = this.$moment(this.match.matchDateTime).format('HH:mm:ss');
      this.scoreType = this.match.scoreType as ScoreType;
      this.homeTeamScore = this.match.homeTeamScore as number;
      this.awayTeamScore = this.match.awayTeamScore as number;
      this.matchReport = this.match.report ? this.match.report : '';
    }
    this.isBusy = false;
  }

  private determineVariantMode() {
    this.editMode = EditMode.General;
    // this.isBeforeMode = this.matchId === undefined || this.matchId === 0 || !this.match || this.match.matchDateTime < new Date();
  }

  private clearForm() {
    this.homeTeamName = '';
    this.awayTeamName = '';
    this.matchDate = '';
    this.matchTime = '';
    this.scoreType = ScoreType.NoScore;
    this.homeTeamScore = this.awayTeamScore = 0;
    this.startingPlayersNames = new Array<string>(11);
    this.startingPlayersNumbers = new Array<number>(11);
    this.substitutionPlayersNames = new Array<string>(7);
    this.substitutionPlayersNumbers = new Array<number>(7);
   }

   private teamsInRange() {
     return this.teams.some((team) => team.shortName === this.homeTeamName) &&
     this.teams.some((team) => team.shortName === this.awayTeamName);
   }

   private getPlayerDisplayName(player: PlayerListItem) {
     return player.lastName + ' ' + player.firstName;
   }
}
